import { __decorate } from "tslib";
import { attr, nullableNumberConverter, observable, } from "@microsoft/fast-element";
import { StartEnd, applyMixins } from "@microsoft/fast-foundation";
import { FormAssociatedSearchBox } from "./search-box.form-associated";
export class SearchBox extends FormAssociatedSearchBox {
    readOnlyChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.readOnly = this.readOnly;
        }
    }
    autocompleteChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.autocomplete = this.autocomplete;
        }
    }
    autofocusChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.autofocus = this.autofocus;
        }
    }
    placeholderChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.placeholder = this.placeholder;
        }
    }
    maxlengthChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.maxLength = this.maxlength;
        }
    }
    minlengthChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.minLength = this.minlength;
        }
    }
    sizeChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.size = this.size;
        }
    }
    spellcheckChanged() {
        if (this.proxy instanceof HTMLElement) {
            this.proxy.spellcheck = this.spellcheck;
        }
    }
    handleEndContentChange() {
        this.endContainer.classList.toggle("end", this.end.assignedNodes().length > 0);
    }
    /**
     * Handler for value changes
     */
    valueChanged() {
        /**
         * FormAssociated should update automatically when the value changes,
         * but that doesn't appear to work at present. As such, we'll update it here.
         * See https://github.com/microsoft/fast/issues/3550
         */
        if (this.$fastController.isConnected) {
            this.setFormValue(this.value);
        }
        if (this.proxy instanceof HTMLElement) {
            this.proxy.value = this.value;
        }
        this.$emit("change");
    }
    /**
     * Submits the search
     */
    submitSearch() {
        var _a;
        this.$emit("submit");
        (_a = this.form) === null || _a === void 0 ? void 0 : _a.submit();
    }
    /**
     * @internal
     */
    connectedCallback() {
        super.connectedCallback();
        if (this.autofocus) {
            this.focus();
        }
        this.setFormValue(this.value, this.value);
    }
    /**
     * @internal
     */
    handleTextInput() {
        if (this.control && this.control.value) {
            this.value = this.control.value;
        }
    }
}
__decorate([
    attr({ attribute: "readonly", mode: "boolean" })
], SearchBox.prototype, "readOnly", void 0);
__decorate([
    attr
], SearchBox.prototype, "autocomplete", void 0);
__decorate([
    attr({ mode: "boolean" })
], SearchBox.prototype, "autofocus", void 0);
__decorate([
    attr
], SearchBox.prototype, "placeholder", void 0);
__decorate([
    attr({ converter: nullableNumberConverter })
], SearchBox.prototype, "maxlength", void 0);
__decorate([
    attr({ converter: nullableNumberConverter })
], SearchBox.prototype, "minlength", void 0);
__decorate([
    attr({ converter: nullableNumberConverter })
], SearchBox.prototype, "size", void 0);
__decorate([
    attr({ mode: "boolean" })
], SearchBox.prototype, "spellcheck", void 0);
__decorate([
    attr({ mode: "boolean" })
], SearchBox.prototype, "isOnImage", void 0);
__decorate([
    attr({ attribute: "button-label" })
], SearchBox.prototype, "buttonLabel", void 0);
__decorate([
    observable
], SearchBox.prototype, "buttonTelemetryTag", void 0);
__decorate([
    observable
], SearchBox.prototype, "inputTelemetryTag", void 0);
__decorate([
    observable
], SearchBox.prototype, "defaultSlottedNodes", void 0);
applyMixins(SearchBox, StartEnd);
